var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { shade, tint, transparentize } from 'polished';
import React, { useContext } from 'react';
import styled, { css, ThemeContext } from 'styled-components';
import { SAIcon, SAIcons } from '../icon';
import { SABox } from '../box';
import { SAButton } from '../button';
import { SAUX360Theme } from '../theme';
var AlertWrapper = styled.div.attrs(function (props) { return props; })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var severity = _a.severity, color = _a.color, theme = _a.theme;
    var baseColor = (color && theme.colors[color]) || theme.colors[severity];
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      display: flex;\n      background: ", ";\n      color: ", ";\n      border: ", " solid ", ";\n      border-left: ", " solid ", ";\n      border-radius: ", ";\n      box-shadow: ", ";\n      .sa-button {\n        color: ", ";\n        &: hover {\n          background-color: ", ";\n        }\n      }\n    "], ["\n      display: flex;\n      background: ", ";\n      color: ", ";\n      border: ", " solid ", ";\n      border-left: ", " solid ", ";\n      border-radius: ", ";\n      box-shadow: ", ";\n      .sa-button {\n        color: ", ";\n        &: hover {\n          background-color: ", ";\n        }\n      }\n    "])), tint(0.9, baseColor), shade(0.5, baseColor), theme.separator.line.thickness, tint(0.7, baseColor), theme.separator.accent.thickness, baseColor, theme.size.radius.small, theme.shadow.elevation.level1, shade(0.5, baseColor), transparentize(0.95, baseColor));
});
var AlertContent = styled(SABox)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  align-items: center;\n  width: 100%;\n"], ["\n  align-items: center;\n  width: 100%;\n"])));
var AlertIconWrapper = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var size = _a.size;
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    width: ", ";\n    flex-basis: ", ";\n    margin-right: 20px;\n    display: flex;\n    align-items: center;\n  "], ["\n    width: ", ";\n    flex-basis: ", ";\n    margin-right: 20px;\n    display: flex;\n    align-items: center;\n  "])), size, size);
});
var AlertChildren = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject([""], [""])));
var AlertButtons = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  margin-left: auto;\n  display: flex;\n"], ["\n  margin-left: auto;\n  display: flex;\n"])));
var iconMapping = function (severity) {
    var icon;
    if (severity === 'success')
        icon = 'success';
    else if (severity === 'info')
        icon = 'information';
    else if (severity === 'warning')
        icon = 'alert';
    else
        icon = 'error';
    return icon;
};
export var SAAlertTitle = styled.h2(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme.font.primary.size.medium);
});
export function SAAlert(_a) {
    var severity = _a.severity, color = _a.color, theme = _a.theme, closeable = _a.closeable, onClose = _a.onClose, actionLabel = _a.actionLabel, onActionClick = _a.onActionClick, icon = _a.icon, children = _a.children, title = _a.title, p = _a.p, pt = _a.pt, pr = _a.pr, pb = _a.pb, pl = _a.pl, px = _a.px, py = _a.py, padding = _a.padding, paddingTop = _a.paddingTop, paddingRight = _a.paddingRight, paddingBottom = _a.paddingBottom, paddingLeft = _a.paddingLeft, paddingX = _a.paddingX, paddingY = _a.paddingY, className = _a.className, additionalProps = __rest(_a, ["severity", "color", "theme", "closeable", "onClose", "actionLabel", "onActionClick", "icon", "children", "title", "p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "className"]);
    var alertIcon = iconMapping(severity);
    var currentTheme = theme || useContext(ThemeContext) || SAUX360Theme;
    var paddingProps = {
        p: p,
        pt: pt,
        pr: pr,
        pb: pb,
        pl: pl,
        px: px,
        py: py,
        padding: padding,
        paddingTop: paddingTop,
        paddingRight: paddingRight,
        paddingBottom: paddingBottom,
        paddingLeft: paddingLeft,
        paddingX: paddingX,
        paddingY: paddingY,
    };
    var paddingValues = Object.values(paddingProps).filter(function (value) { return !!value !== false; });
    var boxPadding = paddingValues.length > 0 ? paddingProps : { padding: 'medium' };
    var iconSize = '24px';
    var iconBaseColor = (theme === null || theme === void 0 ? void 0 : theme.colors[color || severity]) || currentTheme.colors[color || severity];
    var iconOverride = icon && SAIcons[icon];
    return (React.createElement(AlertWrapper, __assign({ color: color, severity: severity, theme: currentTheme, role: "alert", className: "sa-alert-root sa-alert-" + severity + " " + (className || '') }, additionalProps),
        React.createElement(AlertContent, __assign({ display: "flex" }, boxPadding, { className: "sa-alert-content" }),
            icon !== false && (React.createElement(AlertIconWrapper, { size: iconSize },
                React.createElement(SAIcon, { icon: iconOverride || SAIcons[alertIcon], size: iconSize, colorVariant: iconBaseColor }))),
            React.createElement(AlertChildren, { className: "sa-alert-children" },
                title && React.createElement(SAAlertTitle, null, title),
                children),
            React.createElement(AlertButtons, { className: "sa-alert-buttons" },
                onActionClick && actionLabel && (React.createElement(SAButton, { variant: "link-medium", label: "test", onClick: function (e) { return onActionClick(e); }, className: "sa-action-button" }, actionLabel)),
                closeable && onClose && (React.createElement(SAButton, { variant: "link-medium", label: "Close", onClick: function (e) { return onClose(e); }, className: "sa-remove-button" },
                    React.createElement(SAIcon, { icon: SAIcons.x, size: iconSize, colorVariant: shade(0.5, iconBaseColor) })))))));
}
AlertWrapper.defaultProps = {
    theme: SAUX360Theme,
};
SAAlert.defaultProps = {
    theme: undefined,
    color: undefined,
    closeable: false,
    onClose: undefined,
    actionLabel: undefined,
    onActionClick: undefined,
    icon: undefined,
    title: undefined,
    className: undefined,
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
//# sourceMappingURL=alert.component.js.map